<template>
	<div class="mainPage">
		<div class="header_banner">
			<div class="imgBg">
				<img src="../img/chineseCultureVideoExhibition/new_2024/m_banner.png" alt="">
			</div>
			<header>
				<div class="center">
					<div class="right">
						<div v-if="!isLogin" class="loginCon">
							<span @click="toLogin()">{{ $t('message.login') }}</span> /
							<span @click="toLogin()">{{ $t('message.register') }}</span>
						</div>
						<div v-if="isLogin" class="loginCon">
							<span><span class="username">{{ user.username }}</span><span @click="toLogOut()">{{
								$t('message.logout') }}</span> </span>
						</div>
					</div>
				</div>
			</header>
			<div class="infoCon">
				<div class="centerBg">
					<img src="../img/chineseCultureVideoExhibition/new_2024/m_logo_title.png" alt="" class="left">
				</div>
			</div>
		</div>
		<div class="content">

			<div class="leftBox" @mousewheel.prevent>
				<div class="box" v-show="isShowGuide">
					<div class="titleBox" v-for="(item, index) in subject_info" :key="item.id" :class="{ active: active === index }"
						@click="goAnchor('t' + item.id)">
						<div class="title" v-if="item.courseList && item.courseList[0] && item.template == 1">
							<span class="title_cn">{{ item.name }}</span>
							<span class="title_en">{{ item.name_en }}</span>
						</div>
					</div>
					<div class="icon" @click="showDirectory()">
						<img src="../img/chineseCultureVideoExhibition/m_icon2.png" alt="">
					</div>
				</div>
				<div class="icon1" v-show="!isShowGuide" @click="showDirectory()">
					<img src="../img/chineseCultureVideoExhibition/m_icon1.png" alt="">
				</div>
			</div>

			<div class="rightBox">

				<div class="projectProfile">
					<img src="../img/chineseCultureVideoExhibition/m_icon3.png" alt="" class="icon3">
					<div class="box">
						<div class="text">为展现中华文明的深厚底蕴与万千气象，谱写新时代的多彩华章，我们为海外中华文化爱好者、中国语言学习者带来精彩纷呈的视听盛宴，邀您共赏《通向繁荣之路（精编版）》《中国书法大会（精编版）》《寻古中国·玉石记（精编版）》《传承中国：世界遗产在中国》《千秋诗颂》《诗约万里（第三季）》《长城之歌》等中央广播电视总台制作的多语种精品节目，了解中国与世界的交汇共融，感受中华传统文化与现代文明的独特魅力。</div>
						<div class="text2">In order to show the profound heritage and wonderful panorama of Chinese civilization, and to compose colorful chapters of the new era, we present a captivating audiovisual feast for overseas enthusiasts of Chinese culture and learners of the Chinese language. We invite you to indulge in a selection of premium multilingual programs produced by CCTV/CGTN, including The Road to Prosperity (Edited Version), The Tao of Chinese Calligraphy (Edited Version), Discover Ancient Jade (Edited Version), Inheritors: Exploring China’s Living Heritage, Poems of Timeless Acclaim, Poetry Sans Frontiers 3 and The Great Wall. Together, we will explore the convergence and integration between China and the world, and experience the unique charm of traditional Chinese culture alongside modern civilization.</div>
					</div>
					<img src="../img/chineseCultureVideoExhibition/m_icon4.png" alt="" class="icon4">

				</div>



				<div class="classBox" v-for="(subject) in subject_info" :key="subject.id" :ref="subject.id" >

					<div class="classBox1" v-if="subject.courseList && subject.courseList[0] && subject.template == 1">

						<!-- 课程标题 -->
						<div class="titleBox" :id="'t' + subject.id">
							<img :src="subject.extra.schoolLogo" alt="">
						</div>

						<!-- 手机端视频集合 -->
						<div class="swiper_con">

							<swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
								<swiper-slide v-for="(v, index) in subject.courseList" :key="index">
									<div class="video_con" :data-info="v.name">
										<div class="video_cover">
											<img :src="v.cover_url" :alt="v.video_url" class="cover">
											<div class="playBtn" @click="replay(v.video_url, v.cover_url)">
												<img src="../img/chineseCultureVideoExhibition/m_playIcon.png" alt="">
											</div>
										</div>
										<div class="titleBox1">
											<div class="course_title">
												<div class="cn">{{ v.name }}</div>
												<div class="en">{{ v.name_en }}</div>
											</div>
										</div>
									</div>
								</swiper-slide>
								<div class="swiper-pagination swiper-pagination-bullets" slot="pagination" ></div>
								<!-- <div class="swiper-pagination swiper-pagination-bullets" v-if="subject.courseList.length > 8 && subject.courseList.length <= 14 " style="height: 120px" slot="pagination" ></div>
								<div class="swiper-pagination swiper-pagination-bullets" v-if="subject.courseList.length > 14 && subject.courseList.length <= 21 " style="height: 160px" slot="pagination" ></div>
								<div class="swiper-pagination swiper-pagination-bullets" v-if="subject.courseList.length > 21 && subject.courseList.length <= 28 " style="height: 200px" slot="pagination" ></div>
								<div class="swiper-pagination swiper-pagination-bullets" v-if="subject.courseList.length > 28" style="height: 250px" slot="pagination" ></div> -->
							</swiper>
						</div>

						<!-- 课程简介 -->
						<div class="text" v-if="subject.courseList.length <= 7" style="margin-top: .85rem" >
							<div class="text_cn" v-if="subject.courseList && subject.courseList[0] && subject.courseList[0].describe">{{
								subject.courseList[0].describe }}</div>
							<div class="text_en"
								v-if="subject.courseList && subject.courseList[0] && subject.courseList[0].describe_en">{{
									subject.courseList[0].describe_en }}</div>
						</div>

						<!-- 课程简介 -->
						<div class="text" v-if="subject.courseList.length > 7 && subject.courseList.length <= 14 " style="margin-top: 1.6rem" >
							<div class="text_cn" v-if="subject.courseList && subject.courseList[0] && subject.courseList[0].describe">{{
								subject.courseList[0].describe }}</div>
							<div class="text_en"
								v-if="subject.courseList && subject.courseList[0] && subject.courseList[0].describe_en">{{
									subject.courseList[0].describe_en }}</div>
						</div>

						<!-- 课程简介 -->
						<div class="text" v-if="subject.courseList.length > 14 && subject.courseList.length <= 21 " style="margin-top: 2.5rem" >
							<div class="text_cn" v-if="subject.courseList && subject.courseList[0] && subject.courseList[0].describe">{{
								subject.courseList[0].describe }}</div>
							<div class="text_en"
								v-if="subject.courseList && subject.courseList[0] && subject.courseList[0].describe_en">{{
									subject.courseList[0].describe_en }}</div>
						</div>

						<!-- courseIntroduction -->
						<div class="text" v-if="subject.courseList.length > 21 && subject.courseList.length <= 28 " style="margin-top: 3.1rem" >
							<div class="text_cn" v-if="subject.courseList && subject.courseList[0] && subject.courseList[0].describe">{{
								subject.courseList[0].describe }}</div>
							<div class="text_en"
								v-if="subject.courseList && subject.courseList[0] && subject.courseList[0].describe_en">{{
									subject.courseList[0].describe_en }}</div>
						</div>


					</div>

				</div>
			</div>


		</div>

		<div class="footer">
			<div class="copy">Copyright © ChinesePlus</div>
			<div class="bottomBg">

			</div>
			<img src="../img/chineseCultureVideoExhibition/new_2024/m_footer.png" alt="">
		</div>

		<transition name="fade">
			<div id="videoPlayWrapper" v-if="isPlay"  @mousewheel.prevent>
				<div class="videoContent">
					<div class="closeVideo" @click="closeVideo()">×</div>
					<div class="videoContainer">
						<video :src="currentVideoUrl" id="liveVideo" controls autoplay
							controlsList="nodownload">
						</video>
					</div>
				</div>
			</div>
		</transition>

		<div id="menuGuide" v-show="isShowGuide" @click="showDirectory()"  @mousewheel.prevent></div>

	</div>
</template>

<script>
import Qs from 'qs'
import language from './common/language'
export default {
	name: 'chinesebridge',
	components: {
		language
	},
  metaInfo() {
    return {
      title: "多彩华章，中央广播电视总台精品节目展播",
      meta: [
        {
          name: "keyword",
          content:
            "多彩华章，中央广播电视总台精品节目展播",
        },
        {
          name: "description",
          content:
            "多彩华章，中央广播电视总台精品节目展播",
        },
      ],
    };
  },
	data: function () {
		return {
			isChrome: true,
			isLogin: false,
			isPlay: false,
			currentVideoUrl: '',
			user: {
				username: '',
				email: ''
			},
			lang: 'cn',
			isShowGuide: false,
			subjectName: [
				'chinese_Culture_Video_Exhibition1',
				'chinese_Culture_Video_Exhibition2',
				'chinese_Culture_Video_Exhibition3',
				'chinese_Culture_Video_Exhibition4',
				'chinese_Culture_Video_Exhibition5',
				'chinese_Culture_Video_Exhibition6',
				'chinese_Culture_Video_Exhibition7',
				'chinese_Culture_Video_Exhibition8',
				'chinese_Culture_Video_Exhibition9',
				'chinese_Culture_Video_Exhibition10',
				'chinese_Culture_Video_Exhibition11',
				'chinese_Culture_Video_Exhibition12',
			],
			subjectName_en: [
				{
					name: '',
					name_en: 'CLASSIC CHANTING AND SPREADING - POSITIVE YOUTH'
				}
			],
			active: 0,
			subject_info: [],
			courseList: {},
			activeTab: 0,
			subject_id: null,
			subject_name: [],
			subject_subText: [],

			//手机端
			swiperOptionTop: {
				// loop: true,
				loopedSlides: 5, // looped slides should be the same
				spaceBetween: 0,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
					renderBullet(index, className) {
						return `<span class="${className} swiper-pagination-bullet-custom">${index + 1}</span>`
					}
				}
			},


		}
	},
	computed: {
		language() {
			return this.$i18n.locale
		}
	},
	methods: {

		// tolive(url) {
		// 	window.open(url)
		// },
		// 登录
		toLogin() {
			window.location.href =
				this.baseUrl +
				"user/api/login?" +
				"callback=" +
				encodeURIComponent(window.location.href);
		},
		// 注册
		toRegister() {
			window.location.href = 'https://passport.chinesecio.com/static/frontend/dist/#/pc/register?callback=' + encodeURIComponent(window.location.href);
		},
		// 检查是否登录 获取用户信息
		customCheckLogin() {
			this.checkLogin().then(res => {
				if (res.data.success) {
					this.isLogin = true
					this.user = res.data.data
				} else {
					this.isLogin = false
				}
			}).catch((r) => {
				console.log(r)
			})
		},
		// 退出登录
		toLogOut() {
			this.$utils.get('/user/api/logout').then(res => {
				if (res.data.success) {
					this.isLogin = false
				}
			})
		},


		//获取后端专题数据
		async getAllInfo() {

			// 循环获取专题信息
			this.subjectName.forEach((item) => {
				//获取专题数据
				this.getSubjectInfo(item);
				//将标题图片信息添加到数组中
				// console.log('专题信息', this.subject_info)
			})

		},

		// 获取专题信息
		async getSubjectInfo(alias) {
			await this.$utils.get('/subject/subject/readbyalias', {
				alias
			}).then(res => {
				if (res.data.success) {
					//获取课程数据
					if (res.data.data.template == 1){
						this.subject_info.push(res.data.data)
						this.getCourseInfo(res.data.data.id)
					}
				}
			}).catch((r) => {
				console.log(r)
			})
		},

		// 通过专题ID信息 获取课程列表
		async getCourseInfo(id) {
			await this.$utils.get('/subject/lesson/getlist', {
				subject_id: id,
				limit: 200,
				order: 'sort'
			}).then(res => { //处理课程列表
				if (res.data.success) {
					this.courseList = res.data.data.list
					this.subject_info.forEach((item, index) => {
						if (item.id == id) {
							this.$set(this.subject_info[index], "courseList", res.data.data.list)
							this.$forceUpdate()
							// console.log('121212', this.subject_info[index])
						}
					})
					// console.log('课程数据', this.courseList) //所有课程
				}
				//排序
				this.subject_info.sort(this.compare('id'))

			}).catch((r) => {
				console.log(r)
			})
		},

		//排序
		compare(property) {
			return function (a, b) {
				var value1 = a[property];
				var value2 = b[property];
				return value1 - value2;
			}
		},

		// 滚动监听器
		onScroll() {
			// 获取所有锚点元素
			const navContents = document.querySelectorAll('.classBox')
			// 所有锚点元素的 offsetTop
			const offsetTopArr = []
			navContents.forEach(item => {
				offsetTopArr.push(item.offsetTop)
			})
			// console.log(offsetTopArr)
			// 获取当前文档流的 scrollTop
			const scrollTop = document.documentElement.scrollTop
			const clientHeight = document.documentElement.clientHeight
			const scrollHeight = document.documentElement.scrollHeight
			// console.log('top',document.documentElement.scrollTop, offsetTopArr)
			// 定义当前点亮的导航下标
			let navIndex = 0
			for (let n = 0; n < offsetTopArr.length; n++) {
				// 如果 scrollTop 大于等于第n个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
				// 那么此时导航索引就应该是n了
				if (scrollTop >= offsetTopArr[n] - 340) {
					navIndex = n
				}
			}
			if(scrollTop + clientHeight == scrollHeight){
				navIndex = offsetTopArr.length -1
			}
			this.active = navIndex
		},

		goAnchor(selector) {
			// console.log('#'+ selector)
			this.$el.querySelector('#' + selector).scrollIntoView({
				behavior: "smooth", // 平滑过渡
				block: "start", // 上边框与视窗顶部平齐。默认值
			});
		},

		// 关闭导航
		showDirectory() {
			console.log(this.isShowGuide)
			this.isShowGuide = !this.isShowGuide

		},

		//打开导航
		// openDirectory(){
		// 	this.isShowGuide = true
		// },

		//播放课程
		replay(url, cover_url) {
			// console.log(url)
			this.isPlay = true
			this.currentVideoUrl = url
			setTimeout(function () { // 
				$('#liveVideo').bind('contextmenu', function () { return false; }) //为video添加禁止右键另存为操作 
			}, 50)
		},
		closeVideo() {
			var myvideo = document.getElementById("liveVideo");
			if (!myvideo.paused) { //视频正在播放中时停止播放
				myvideo.pause();
			}
			this.isPlay = false
		},
		checkChrome() {
			var isChrome = window.navigator.userAgent.indexOf("Chrome") > -1;
			if (!isChrome) {
				this.isChrome = false
			}
		}
	},


	created() {
		this.getAllInfo()
	},
	mounted() {

		this.customCheckLogin()
		// this.getAllInfo()
		this.checkChrome()
		// 监听滚动事件
		window.addEventListener('scroll', this.onScroll, false)

		let activeTab = this.$route.query.tab
		if (activeTab) {
			this.activeTab = activeTab
		}

	},
	destroy() {
		// 移除监听器
		window.removeEventListener('scroll', this.onScroll)
	},


}
</script>


<style scoped lang="scss">
.mainPage {
	width: 100%;
	text-align: center;
	position: relative;
	min-height: 100%;
	// background-color: #ebf0f9;
	// background: linear-gradient(to right, #def3fd61, #ffdae23d);
	user-select: none;


	.agentTip {
		width: 100%;
		height: 70px;
		line-height: 70px;
		background-color: #ffe6a1;
		text-align: center;
		position: absolute;
		z-index: 5;
		color: #c40000;
	}

	.agentTip .closeTip {
		position: absolute;
		right: 24px;
		top: 0px;
		font-size: 30px;
		color: #282828;
		cursor: pointer;
	}

	.header_banner {
		// position: relative;
		// background-image: url(../img/chineseCultureVideoExhibition/m_banner.png);
		// height: 285px;
		// background-size: cover;
		// background-repeat: no-repeat;
		// background-position: center;

		.imgBg {
			max-width: 100%;
			height: auto;
			position: absolute;
			z-index: -1;

			img {
				width: 100%;
			}
		}

		header {
			position: absolute;
			height: 50px;
			line-height: 50px;
			z-index: 2;
			// border-bottom: 1px solid rgba(#fff, 0.3);
			top: 0;
			width: 100%;
			margin: auto;
			color: #fff;

			.center {
				color: #8590cc;
				width: 90%;
				margin: auto;

				a {
					color: #8590cc;
					margin-right: 15px;
					// opacity: 0.8;
				}
			}

			.left {
				float: left;
			}

			.right {
				line-height: 50px;
				float: right;

				img {
					vertical-align: text-top;
					margin-right: 15px;
				}

				.loginCon {
					display: inline-block;
					margin-left: 30px;

					span {
						cursor: pointer;
					}

					.username {
						margin-right: 12px;
					}
				}
			}
		}

		.infoCon {

			.centerBg {
				width: 88%;
				margin: auto;

				img {
					margin-top: 25px;
					max-width: 97%;
					height: auto;
				}

			}
		}
	}

	.content {
		display: flex;
		flex-direction: row;
		justify-content: center;
		// max-width: 1400px;
		// height: 2860px;
		margin: auto;
		// margin-top: -125px;



		.leftBox {
			position: fixed;
			// width: 65%;
			top: 50px;
			right: 0px;
			background-color: #fff;
			border-radius: 5px 0 0 5px;
			box-shadow: -5px 5px 20px 0px #888888;
			text-align: end;
			z-index: 10000;

			.box {
				display: flex;
				flex-direction: column;
				margin-right: 30px;
				margin-left: 20px;
				margin-top: 20px;
				margin-bottom: 20px;
				// animation: my-animation1 0.5s ease-in-out;
				// @keyframes my-animation1 {
				// 	0% { transform: scale(.5); }
				// 	100% { transform: scale(1); }
				// }

				.titleBox {
					// padding: 7px 10px;
					display: flex;
					justify-content: flex-end;
					align-items: center;
					cursor: pointer;

					.title {
						padding: 7px 10px;
						display: flex;
						flex-direction: column;
						margin-right: 45px;

						.title_cn {
							font-size: 18px;
							line-height: 30px;
						}

						.title_en {
							font-size: 12px;
							font-family: DINCond-Medium;
						}

					}

					// .icon {
					// 	width: 30px;
					// 	height: 30px;
					// 	display: none;
					// }
				}

				.titleBox.active {
					.title {
						color: darkorange;
						margin-right: 45px;
					}

					// .icon {
					// 	display: block;
					// }
				}


			}

			.icon {
				position: absolute;
				bottom: 57px;
				right: 15px;
				width: 40px;
				height: 0px;

				img {
					width: 100%;
				}
			}

		}

		.icon1 {
			position: absolute;
			// bottom: 18px;
			top: 420px;
			right: 10px;
			width: 50px;
			height: 50px;
			z-index: 9999;

			// animation: my-animation 0.5s ease-in-out;
			// @keyframes my-animation {
			// 		0% { transform: scale(.5); }
			// 		100% { transform: scale(1); }
			// 	}
			img {
				width: 100%;
			}

		}



		.rightBox {
			width: 96%;
			display: flex;
			flex-direction: column;
			// text-align: left;

			.projectProfile {
				position: relative;
				margin-top: 9px;

				.icon3 {
					width: 55%;
					position: absolute;
					left: 0px;
					top: 0px;
				}

				.icon4 {
					width: 55%;
					position: absolute;
					right: 20px;
					bottom: 30px;
				}

				.kuang1 {
					position: absolute;
					margin-top: 10px;
					z-index: 100;
				}

				.box {
					width: 95%;
					// height: 250px;
					border-radius: 10px;
					background-color: #fdfbfb;
					opacity: 0.7;
					z-index: 10;
					margin: auto;
					margin-top: 10px;
					margin-bottom: 40px;

					.text {
						font-size: 15px;
						color: #282828;
						padding-top: 15px;
						padding-left: 15px;
						padding-right: 15px;
						line-height: 20px;
						text-align: justify;
						text-indent: 2em;
					}

					.text2 {
						font-size: 14px;
						color: #282828;
						padding-left: 15px;
						padding-right: 15px;
						line-height: 20px;
						padding-bottom: 15px;
						text-align: justify;
						// text-indent:2em;
					}
				}
			}


			.classBox {
				position: relative;
				background-color: #fff;
				margin-top: 1.2rem;
				border-radius: 12px 12px 12px 12px;

				.titleBox {
					width: auto;
					height: 1.2rem;
					position: absolute;
					z-index: 10;
					top: -0.8rem;
					left: -0.1rem;

					img {
						width: auto;
						height: 100%;
					}
				}

				.text {
					margin-top: 1.3rem;
					padding: 10px 15px 20px;
					text-align: justify;
				}

				.text_cn {
					font-size: 16px;
					color: #5e696d;
					line-height: 24px;
					margin-top: 20px;
					margin-bottom: 5px;
				}

				.text_en {
					font-size: 14px;
					color: #5e696d;
					line-height: 20px;
					// margin-bottom: 20px;
				}

				.swiper_con {
					// margin-top: 25px;
					margin-left: 0rem;
					// margin-bottom: 40px;
					position: relative;

					.swiper-container {
						position: unset;
					}

					.swiper ::v-deep {
						.swiper-slide {
							// width: 7.2rem !important;

							.swiperBox {
								overflow: hidden;
							}
						}

						.video_con {
							width: 7.2rem;

							.video_cover {
								width: 7.2rem;
								height: calc(7.2rem / (16/9));
								background-color: #ffae00;
								// border-radius: .2rem;
								// border: solid .04rem #000000;
								// overflow: hidden;
								// margin-top: -.4rem;

								img {
									display: block;
									width: 100%;
									height: 100%;
									cursor: pointer;
								}

							}

							.playBtn {
								position: absolute;
								width: 0.8rem;
								height: 0.9rem;
								bottom: 1rem;
    						right: 0.4rem;
								z-index: 10;
								animation: my-animation 1.5s ease-in-out infinite;

								@keyframes my-animation {
									0% {
										transform: scale(.8);
									}

									50% {
										transform: scale(1);
									}

									100% {
										transform: scale(.8);
									}

								}

								img {}
							}

							.titleBox1 {
								position: absolute;
								height: 55px;
								margin-top: -55px;
								width: 100%;
								color: #fff;
								background-color: #55565775;
								text-align: left;
								bottom: 0;
								z-index: 100;
								display: flex;
    						align-items: center;

								.course_title {
									padding: 10px 20px;

									.cn {
										font-size: 16px;
									}

									.en {
										margin-top: 4px;
										font-size: 14px;
										// line-height: 12px;
									}
								}
							}

							// .title {
							// 	position: absolute;
							// 	width: 100%;
							// 	color: #000;
							// 	text-align: left;
							// 	z-index: 100;

							// 	.cn {
							// 		font-size: 16px;
							// 	}

							// 	.en {
							// 		margin-top: 4px;
							// 		font-size: 14px;
							// 	}
							// }
						}

						.video_con2 {
							width: 1rem;
							background-color: #c40000;

							.checkBox {
								width: 1rem;
								height: 1rem;
								background-color: #ffae00;

							}
						}

						.swiper-pagination-bullets {
							// height: 80px;
							top: 4.2rem;
							text-align: left;
							display: flex;
							flex-wrap: wrap;
							align-items: center;
							margin-left: 10px;

							.swiper-pagination-bullet-custom {
								// $size: 20px;
								border-radius: 0.14rem;
								border: solid 1px #5e696d;
								width: 0.7rem !important;
								height: 0.7rem !important;
								line-height: 0.7rem !important;
								text-align: center;
								color: #5e696d;
								background: #deeaee;
								transition: all 0.5s;

								margin-right: 8px;
								margin-top: 4px;

								// &:hover {
								// 	opacity: 0.8;
								// 	color: #eb7f66;
								// 	border: solid 1px #eb7f66;
								// 	background: rgba(#fceeeb, 0.6);
								// }

								&.swiper-pagination-bullet-active {
									opacity: 1;
									color: #eb7f66;
									border: solid 1px #eb7f66;
									background: rgba(#fceeeb, 0.6);
								}
							}

						}



					}

					.gallery-top {
						width: 7.2rem;
						height: calc(7.2rem / (16/9));
						border-radius: 12px 12px 0 0;
					}

					.gallery-thumbs {
						height: 20%;
						box-sizing: border-box;
						// padding: 10px 0;
						width: 1rem;
					}

					.gallery-thumbs .swiper-slide {
						height: 100%;
						opacity: 0.4;
						width: 1rem !important;
					}

					.gallery-thumbs .swiper-slide-active {
						opacity: 1;
					}

					.swiper-button-prev {
						background-image: url(../img/chineseCultureVideoExhibition/prev.png);
						position: absolute;
						left: -75px;
						top: 90px;
					}

					.swiper-button-next {
						background-image: url(../img/chineseCultureVideoExhibition/next.png);
						right: -75px;
						top: 90px;
					}


				}

			}
		}
	}

	.footer {
		margin-top: 80px;

		.copy {
			position: absolute;
			bottom: 70px;
			width: 100%;
			text-align: center;
			font-weight: 600;
		}

		img {
			width: 100%;
		}
	}



	#videoPlayWrapper {
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.88);
		z-index: 9999;
	}

	#menuGuide {
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.8);
		z-index: 9999;
	}

	#videoPlayWrapper .closeVideo {
		position: absolute;
		right: 20px;
		top: 10px;
		font-size: 50px;
		color: #fff;
		cursor: pointer;
	}

	.videoContent {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.videoContainer {
		text-align: center;
		width: 100%;
	}

	.videoContainer video {
		width: 100%;
	}

	video::-internal-media-controls-download-button {
		display: none;
	}

	video::-webkit-media-controls-enclosure {
		overflow: hidden;
	}

	video::-webkit-media-controls-panel {
		width: calc(100% + 30px);
	}
}

</style>
